import { c } from 'ttag';
export const UnknownContactName = c('B6.Preferences.Vaults.Label').t `Unnamed contact`;
